import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * Activity catalog fuzzy-search (also served by api-activity-v2-service).
 * Same envelope shape as api-medicine-service — `{data: [...]}` — so the
 * caller doesn't need to know it.
 *
 * Response entries: { id, name, category }
 */
class ActivityCatalogService {
  constructor() {
    this.apiService = new APIService();
  }

  search(queryString, onResponse, onError) {
    const q = encodeURIComponent((queryString || "").trim());
    const url = APIConfig.activityCatalog.search.format(q);
    return this.apiService.get(
      url,
      (res) => onResponse((res && res.data) || []),
      onError
    );
  }
}

export default ActivityCatalogService;
